module.exports = __webpack_public_path__ + "img/chinesecompany86.f379abff.png";